import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { PopoverController } from '@ionic/angular';

@Component({
  selector: 'app-popover-game-history-details',
  templateUrl: './popover-game-history-details.component.html',
  styleUrls: ['./popover-game-history-details.component.scss'],
})
export class PopoverGameHistoryDetailsComponent implements OnInit {

  @Input() data: any;
  dataFromParent: any;

  constructor(
    public popoverController: PopoverController,
    private sanitizer:DomSanitizer
  ){
  }

   onClosePopover = () => {
    this.popoverController.dismiss();
  }

  ngOnInit(): void {
    this.dataFromParent = this.sanitizer.bypassSecurityTrustHtml(this.data.message);
    
  }

}
